var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _radialGradient, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCanyon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 240.758,
    x2: 268.268,
    y1: 354.258,
    y2: 489.694
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcb37e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1704,
    stopColor: "#f0aa76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4808,
    stopColor: "#cf9362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8934,
    stopColor: "#9b6d42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c6239"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c6239",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c6239"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 276.72,
    x2: 217.72,
    xlinkHref: "#lg1",
    y1: 462.798,
    y2: 252.798
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ab272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3386,
    stopColor: "#47b071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5502,
    stopColor: "#3fa870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#309b6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8837,
    stopColor: "#1c8869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#077565"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.073,
    x2: 66.196,
    xlinkHref: "#lg2",
    y1: 351.202,
    y2: 419.675
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#91f27f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffed82"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.272,
    x2: 22.324,
    xlinkHref: "#lg3",
    y1: 398.13,
    y2: 333.392
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ab272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 76.197,
    x2: 111.121,
    xlinkHref: "#lg4",
    y1: 396.771,
    y2: 331.817
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_6_",
    cx: 303.082,
    cy: 126.148,
    gradientUnits: "userSpaceOnUse",
    r: 123.658
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa325"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4235,
    stopColor: "#ffa126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#ff992b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8052,
    stopColor: "#ff8c33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9474,
    stopColor: "#ff793e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 348.905,
    x2: 230.183,
    y1: 181.501,
    y2: 62.778
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd945"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 373.824,
    x2: 558.7,
    y1: 167.988,
    y2: 11.504
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f35227",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f35227"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.436,
    x2: 259.257,
    xlinkHref: "#lg5",
    y1: 119.601,
    y2: 423.288
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbed21"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 252.337,
    x2: 8.739,
    xlinkHref: "#lg6",
    y1: 313.161,
    y2: 115.114
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 180.668,
    x2: 114.668,
    xlinkHref: "#lg7",
    y1: 294.523,
    y2: 393.857
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.804,
    x2: 135.122,
    xlinkHref: "#lg7",
    y1: 255.371,
    y2: 378.306
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 295.143,
    x2: 200.143,
    xlinkHref: "#lg7",
    y1: 134.951,
    y2: 389.951
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.659,
    x2: 338.343,
    xlinkHref: "#lg5",
    y1: 319.634,
    y2: 460.317
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.6,
    x2: 202.6,
    xlinkHref: "#lg7",
    y1: 309.424,
    y2: 436.424
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 249.13,
    x2: 182.799,
    xlinkHref: "#lg6",
    y1: 345.085,
    y2: 324.295
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 432.038,
    x2: 410.04,
    xlinkHref: "#lg1",
    y1: 450.28,
    y2: 371.984
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.086,
    x2: 428.041,
    y1: 347.229,
    y2: 358.806
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ab272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#077565"
  }))), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg8"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#91f27f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#119786"
  }))), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 404.193,
    x2: 419.904,
    xlinkHref: "#lg8",
    y1: 344.898,
    y2: 350.72
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.797,
    x2: 419.581,
    xlinkHref: "#lg8",
    y1: 345.99,
    y2: 349.71
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 413.842,
    x2: 399.845,
    xlinkHref: "#lg3",
    y1: 350.251,
    y2: 340.498
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg9"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005a01",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005a01"
  }))), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 416.921,
    x2: 390.952,
    xlinkHref: "#lg9",
    y1: 364.873,
    y2: 353.308
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg10"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#91f27f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b302"
  }))), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 373.48,
    x2: 405.417,
    xlinkHref: "#lg10",
    y1: 362.679,
    y2: 362.679
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 410.779,
    x2: 356.083,
    xlinkHref: "#lg10",
    y1: 362.679,
    y2: 362.679
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 380.619,
    x2: 398.14,
    xlinkHref: "#lg10",
    y1: 362.679,
    y2: 362.679
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 398.895,
    x2: 359.891,
    xlinkHref: "#lg3",
    y1: 367.494,
    y2: 352.546
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 391.149,
    x2: 350.491,
    xlinkHref: "#lg9",
    y1: 382.363,
    y2: 356.227
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 359.963,
    x2: 386.897,
    xlinkHref: "#lg10",
    y1: 350.417,
    y2: 377.253
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg11"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#91f27f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b302"
  }))), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 370.796,
    x2: 352.202,
    xlinkHref: "#lg11",
    y1: 353.658,
    y2: 365.905
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 354.504,
    x2: 384.96,
    xlinkHref: "#lg11",
    y1: 361.553,
    y2: 345.712
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.5,
    x2: 424.153,
    xlinkHref: "#lg9",
    y1: 348.149,
    y2: 363.682
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 366.351,
    x2: 346.101,
    xlinkHref: "#lg3",
    y1: 354.996,
    y2: 349.988
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 400.832,
    x2: 414.556,
    xlinkHref: "#lg2",
    y1: 380.942,
    y2: 414.358
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 410.201,
    x2: 393.146,
    xlinkHref: "#lg3",
    y1: 403.844,
    y2: 372.25
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 419.437,
    x2: 436.481,
    xlinkHref: "#lg4",
    y1: 403.181,
    y2: 371.482
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m510 424.942c0 33.186-510 33.186-510 0s114.167-60.089 255-60.089 255 26.903 255 60.089z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 364.853c-109.752 0-203.302 16.339-239.251 39.258l1.407 2.177 34.398 34.398c129.544 16.155 458.446 10.907 458.446-15.743 0-33.187-114.167-60.09-255-60.09z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m96.714 395.288c0 2.165-.159 4.294-.465 6.373-.646 4.392-4.336 7.628-8.653 7.628h-63.909c-4.299 0-7.996-3.206-8.644-7.578-.425-2.865-.57-5.825-.406-8.845 1.219-22.388 19.62-40.045 41.413-39.83 6.458.064 12.548 1.655 17.965 4.453.422.217.837.442 1.252.675.52.287 1.04.6 1.56.921 1.181.731 2.326 1.522 3.427 2.374.286.222.574.445.852.678.37.295.724.598 1.079.908.362.31.709.629 1.056.947.007.008.015.015.023.015.332.326.664.644.996.97 1.003 1.001 1.954 2.057 2.852 3.159 1.207 1.467 2.308 3.019 3.297 4.649.249.404.49.815.732 1.234.234.419.468.838.686 1.265.226.427.438.854.649 1.288.211.435.407.869.603 1.312.226.505.438 1.009.634 1.521.158.388.309.784.445 1.18.143.38.272.761.4 1.149.189.574.362 1.156.528 1.731.128.442.241.885.355 1.335.121.473.226.947.324 1.42.189.885.355 1.785.483 2.685.038.217.068.435.091.652.053.38.098.753.136 1.141.045.442.09.885.121 1.335.015.155.023.31.03.466.03.396.045.792.06 1.195v.085c.021.5.028 1.005.028 1.509z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.925 395.288c0 4.975-1.003 9.709-2.814 14.001h-62.937c-1.803-4.292-2.806-9.027-2.806-14.001 0-19.473 15.344-35.268 34.279-35.268 8.336 0 15.985 3.066 21.93 8.165 7.543 6.474 12.348 16.214 12.348 27.103z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.714 395.288c0 2.165-.159 4.294-.465 6.373-.646 4.392-4.336 7.628-8.653 7.628h-24.55c9.339-7.738 15.306-19.605 15.306-32.901 0-2.802-.272-5.549-.777-8.204-.724-3.772-1.931-7.358-3.561-10.695.422.217.837.442 1.252.675.407.225.815.466 1.222.714 1.207.73 2.376 1.529 3.508 2.383.37.287.747.574 1.109.877.37.295.724.598 1.079.908.362.31.709.629 1.056.947.007.008.015.015.023.015.332.326.664.644.996.97.996 1.001 1.954 2.057 2.852 3.159 1.199 1.467 2.301 3.019 3.297 4.649.249.404.49.815.732 1.234.234.419.468.838.686 1.265.226.427.438.854.649 1.288.211.435.407.869.603 1.312.226.505.438 1.009.634 1.521.158.388.309.784.445 1.18.143.38.272.761.4 1.149.189.574.362 1.156.528 1.731.128.442.241.885.355 1.335.121.473.226.947.324 1.42.189.885.355 1.785.483 2.685.038.217.068.435.091.652.053.38.098.753.136 1.141.045.442.09.885.121 1.335.015.155.023.31.03.466.03.396.045.792.06 1.195v.085c.022.499.029 1.004.029 1.508z",
    fill: "url(#SVGID_5_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 331.665,
    cy: 164.26,
    fill: "url(#SVGID_6_)",
    r: 99.245
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.665,
    cy: 164.26,
    fill: "url(#SVGID_7_)",
    r: 88.589
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.06 75.482c6.695 13.36 10.467 28.436 10.467 44.395 0 54.812-44.434 99.246-99.245 99.246-15.959 0-31.036-3.773-44.396-10.467 16.296 32.521 49.926 54.85 88.779 54.85 54.812 0 99.245-44.434 99.245-99.245-.001-38.853-22.328-72.484-54.85-88.779z",
    fill: "url(#SVGID_8_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m258.007 149.489v-23.383c0-7.119-5.771-12.89-12.89-12.89-7.119 0-12.89-5.771-12.89-12.89v-24.4c0-9.792-8.838-17.212-18.482-15.517l-85.898 15.1c-7.533 1.324-13.027 7.868-13.027 15.517v87.32c0 11.627-6.284 22.346-16.43 28.025l-12.199 6.828c-9.647 5.4-15.839 15.382-16.39 26.424l-8.475 160.465c-.264 5.001 3.72 9.201 8.728 9.201h270.73c4.827 0 8.74-3.913 8.74-8.74v-159.326c0-13.018-7.136-24.988-18.588-31.179l-54.34-29.377c-11.453-6.19-18.589-18.16-18.589-31.178z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.002 213.199c-9.647 5.4-15.839 15.382-16.39 26.424l-8.912 169.666h251.082c4.827 0 8.74-3.913 8.74-8.74v-159.326c0-13.018-7.136-24.988-18.588-31.179l-54.34-29.377c-11.452-6.191-18.588-18.161-18.588-31.179v-23.382c0-7.178-5.873-12.802-13.051-12.891-7.044-.087-12.728-5.824-12.728-12.889v-24.4c0-5.215-2.52-9.739-6.32-12.59l-69.248 12.174c-7.533 1.324-13.027 7.868-13.027 15.517v87.32c0 11.627-6.284 22.346-16.43 28.025z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.86 224.33h82v184.96h-82z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.621 156.616h65.712v252.674h-65.712z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330.935 210.045-54.34-29.377c-11.452-6.191-18.588-18.161-18.588-31.179v-23.382c0-7.178-5.873-12.802-13.051-12.891-7.044-.087-12.728-5.824-12.728-12.889v-24.4c0-9.792-8.838-17.212-18.482-15.517l-47.885 8.418c1.075 2.124 1.699 4.525 1.699 7.099v24.4c0 7.178 5.873 12.802 13.051 12.891 7.044.087 12.728 5.824 12.728 12.889v23.382c0 13.018 7.136 24.988 18.588 31.179l54.34 29.377c11.452 6.191 18.588 18.161 18.588 31.179v168.066h55.929c4.827 0 8.74-3.913 8.74-8.74v-159.327c-.001-13.017-7.138-24.988-18.589-31.178z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.651 405.388v3.901h251.131c4.827 0 8.74-3.913 8.74-8.74v-25.122l-8.738-4.891c-10.146-5.679-16.43-16.398-16.43-28.025v-87.319c0-7.649-5.494-14.193-13.027-15.517l-85.898-15.1c-9.644-1.695-18.482 5.725-18.482 15.517v24.401c0 7.119-5.771 12.889-12.889 12.889-7.119 0-12.89 5.771-12.89 12.89v23.383c0 13.018-7.136 24.988-18.588 31.179l-54.34 29.376c-11.453 6.19-18.589 18.16-18.589 31.178z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m349.52 375.43v25.12c0 4.827-3.913 8.74-8.74 8.74l-38.19-20.64c-11.45-6.19-18.58-18.16-18.58-31.18v-23.38c0-3.56-1.44-6.78-3.77-9.11-2.314-2.314-5.488-3.748-9.001-3.779-7.129-.065-13.009-5.528-13.009-12.658v-24.633c0-9.8-8.84-17.22-18.48-15.52l-38.43 6.76c3.4-2.33 5.63-6.23 5.63-10.66v-24.4c0-9.79 8.83-17.21 18.48-15.52l85.9 15.1c7.53 1.33 13.02 7.87 13.02 15.52v87.32c0 11.63 6.29 22.35 16.43 28.03z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m349.523 400.549v-17.32c-1.704-3.03-2.917-6.335-3.568-9.799l-5.171-2.895c-10.146-5.679-16.43-16.398-16.43-28.024v-79.257l-77.889-13.692c-9.644-1.695-18.482 5.725-18.482 15.517v24.4c0 7.119-5.771 12.889-12.889 12.889-7.119 0-12.89 5.771-12.89 12.89v23.383c0 13.018-7.136 24.988-18.588 31.179l-54.34 29.376c-4.649 2.513-8.571 5.991-11.609 10.093h223.116c4.826 0 8.74-3.913 8.74-8.74z",
    fill: "url(#SVGID_16_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m421.833 386.279s-6.582-5.734-16.416-4.023h-31.937v20.878l40.956 41.736c23.356-1.695 43.73-3.824 59.599-6.388z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m402.3 365.933h1.505c10.919 0 19.802-8.883 19.802-19.802v-10.119c0-3.919-3.177-7.096-7.096-7.096s-7.096 3.177-7.096 7.096v10.119c0 3.094-2.517 5.611-5.611 5.611h-1.504c-3.919 0-7.096 3.177-7.096 7.095 0 3.919 3.177 7.096 7.096 7.096z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403.805 364.041c9.876 0 17.91-8.034 17.91-17.91v-12.011c0-2.869-2.334-5.203-5.203-5.203s-5.203 2.334-5.203 5.203v12.011c0 4.137-3.366 7.503-7.503 7.503h-3.397c-2.869 0-5.203 2.334-5.203 5.203s2.334 5.203 5.203 5.203h3.396z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403.805 360.824c8.102 0 14.694-6.591 14.694-14.693v-15.228c0-1.095-.891-1.987-1.987-1.987s-1.987.891-1.987 1.987v15.228c0 5.911-4.809 10.72-10.72 10.72h-6.614c-1.095 0-1.987.891-1.987 1.987s.891 1.987 1.987 1.987h6.614z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.607 346.131v-9.989c0-3.913-3.113-7.188-7.027-7.225-.03 0-.06 0-.09 0-1.114.003-2.166.568-2.767 1.506-.706 1.102-1.115 2.412-1.115 3.818v13.667c0 3.099-2.512 5.611-5.611 5.611h-1.376c-3.974 0-7.295 3.252-7.224 7.226.035 1.953.861 3.713 2.169 4.975.555.139 1.135.214 1.733.214h1.505c10.937-.001 19.803-8.867 19.803-19.803z",
    fill: "url(#SVGID_21_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m405.418 351.505c-.511.154-1.052.237-1.613.237h-1.505c-3.919 0-7.096 3.177-7.096 7.095 0 3.919 3.177 7.096 7.096 7.096h1.505c4.503 0 8.658-1.512 11.988-4.053z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m389.448 319.07c-8.819 0-15.968 7.149-15.968 15.968v67.78c0 1.916 7.149 3.469 15.968 3.469s15.968-1.553 15.968-3.469v-67.78c.001-8.818-7.148-15.968-15.968-15.968z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400.313 335.039v70.322c-2.85.575-6.668.927-10.865.927s-8.015-.352-10.865-.927v-70.322c0-8.819 4.864-15.968 10.865-15.968 6.001-.001 10.865 7.149 10.865 15.968z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m389.448 406.288c-1.512 0-2.974-.046-4.361-.132v-71.118c0-8.819 1.952-15.968 4.361-15.968 2.408 0 4.361 7.149 4.361 15.968v71.118c-1.386.086-2.848.132-4.361.132z",
    fill: "url(#SVGID_25_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m376.477 404.843c2.899.875 7.628 1.446 12.971 1.446 8.819 0 15.968-1.553 15.968-3.469v-67.78c0-8.819-7.149-15.968-15.968-15.968-.005 0-.01 0-.015 0-.979.001-1.949.193-2.864.538-5.957 2.244-10.092 7.569-10.092 16.234z",
    fill: "url(#SVGID_26_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m405.417 402.819v-16.043l-24.533-24.533c-1.3-1.473-3.201-2.404-5.321-2.404h-1.505c-.195 0-.388-.01-.578-.03v14.212l30.32 30.32c1.035-.46 1.617-.976 1.617-1.522z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m375.563 374.03h-1.505c-10.919 0-19.802-8.883-19.802-19.802v-10.119c0-3.919 3.177-7.095 7.096-7.095s7.096 3.177 7.096 7.095v10.119c0 3.094 2.517 5.611 5.611 5.611h1.505c3.919 0 7.096 3.177 7.096 7.096s-3.179 7.095-7.097 7.095z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.058 372.138c-9.876 0-17.91-8.034-17.91-17.91v-12.011c0-2.869 2.334-5.203 5.203-5.203s5.203 2.334 5.203 5.203v12.011c0 4.137 3.366 7.503 7.503 7.503h3.397c2.869 0 5.203 2.334 5.203 5.203s-2.334 5.203-5.203 5.203h-3.396z",
    fill: "url(#SVGID_29_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.058 368.921c-8.102 0-14.694-6.591-14.694-14.693v-15.228c0-1.095.891-1.987 1.987-1.987s1.987.891 1.987 1.987v15.228c0 5.911 4.809 10.72 10.72 10.72h6.614c1.095 0 1.987.891 1.987 1.987 0 1.095-.891 1.987-1.987 1.987h-6.614z",
    fill: "url(#SVGID_30_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m382.658 366.934c0-2.868-2.335-5.203-5.203-5.203h-3.396c-4.138 0-7.504-3.366-7.504-7.504v-12.009c0-2.87-2.335-5.203-5.203-5.203 3.919 0 7.096 3.177 7.096 7.096v10.117c0 3.096 2.517 5.612 5.612 5.612h1.504c3.918-.001 7.094 3.176 7.094 7.094z",
    fill: "url(#SVGID_31_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m375.434 359.839h-1.376c-3.099 0-5.611-2.512-5.611-5.611v-10.119c0-3.919-3.177-7.095-7.096-7.095-.004 0-.008 0-.011 0-.764.001-1.49.335-2.018.887-1.221 1.274-1.971 3.003-1.971 4.907v11.421c0 10.58 8.341 19.249 18.792 19.777 3.674-.297 6.558-3.391 6.516-7.151-.045-3.91-3.317-7.016-7.225-7.016z",
    fill: "url(#SVGID_32_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m429.45 402.457c0 1.057-.077 2.096-.227 3.11-.315 2.143-2.116 3.723-4.223 3.723h-31.189c-2.098 0-3.902-1.565-4.219-3.698-.207-1.398-.278-2.843-.198-4.316.595-10.926 9.575-19.543 20.211-19.438 3.152.031 6.124.808 8.767 2.173.206.106.409.216.611.33.254.14.507.293.761.45.576.357 1.135.743 1.672 1.159.14.108.28.217.416.331.18.144.353.292.526.443.177.151.346.307.515.462.004.004.007.008.011.008.162.159.324.314.486.473.49.489.954 1.004 1.392 1.542.589.716 1.127 1.473 1.609 2.269.122.197.239.398.357.602.114.204.228.409.335.617.11.208.214.417.317.629s.199.424.294.64c.11.246.214.492.309.742.077.189.151.383.217.576.07.186.133.371.195.561.092.28.177.564.258.845.063.216.118.432.173.651.059.231.11.462.158.693.092.432.173.871.236 1.311.018.106.033.212.044.318.026.186.048.367.066.557.022.216.044.432.059.652.007.076.011.151.015.227.015.193.022.386.029.583v.042c.013.24.017.487.017.733z",
    fill: "url(#SVGID_33_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m426.136 402.457c0 2.428-.49 4.738-1.373 6.833h-30.715c-.88-2.095-1.37-4.405-1.37-6.833 0-9.503 7.488-17.211 16.729-17.211 4.068 0 7.801 1.496 10.702 3.985 3.682 3.158 6.027 7.912 6.027 13.226z",
    fill: "url(#SVGID_34_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m429.45 402.457c0 1.057-.077 2.096-.227 3.11-.315 2.143-2.116 3.723-4.223 3.723h-11.981c4.558-3.776 7.47-9.568 7.47-16.056 0-1.367-.133-2.708-.379-4.004-.353-1.841-.942-3.591-1.738-5.219.206.106.409.216.611.33.199.11.398.227.596.348.589.356 1.16.746 1.712 1.163.18.14.364.28.541.428.18.144.353.292.526.443.177.151.346.307.515.462.004.004.007.008.011.008.162.159.324.314.486.473.486.489.954 1.004 1.392 1.542.585.716 1.123 1.473 1.609 2.269.122.197.239.398.357.602.114.204.228.409.335.617.11.208.214.417.317.629s.199.424.294.64c.11.246.214.492.309.742.077.189.151.383.217.576.07.186.133.371.195.561.092.28.177.564.258.845.063.216.118.432.173.651.059.231.11.462.158.693.092.432.173.871.236 1.311.018.106.033.212.044.318.026.186.048.367.066.557.022.216.044.432.059.652.007.076.011.151.015.227.015.193.022.386.029.583v.042c.013.241.017.488.017.734z",
    fill: "url(#SVGID_35_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCanyon);
export default __webpack_public_path__ + "static/media/icon-canyon.3cb9e05a7debcacbe3a356eb0a1e5837.svg";
export { ForwardRef as ReactComponent };